import { u8aToHex } from '../helpers';
export async function sha256(bytes) {
    if (window.crypto === undefined) {
        throw new Error('window.crypto API not available');
    }
    if (window.crypto.subtle === undefined) {
        throw new Error('window.subtle API not available');
    }
    const buf = await crypto.subtle.digest('SHA-256', bytes);
    return u8aToHex(new Uint8Array(buf));
}
